import { useRef } from 'react';

import useIntervalUpdate from '@zenbusiness/application-commons-hooks/useIntervalUpdate';
import Center from '@zenbusiness/zui/Center';
import CircularProgress from '@zenbusiness/zui/CircularProgress';
import Container from '@zenbusiness/zui/Container';
import Heading from '@zenbusiness/zui/Heading';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

export const INTERSTITIAL_DELAY = 3000;

function Interstitial({ children }) {
  const now = Date.now();
  const { current: startTime } = useRef(now);

  useIntervalUpdate(500);

  const expiresAt = startTime + INTERSTITIAL_DELAY;
  const progress = Math.round(((now - startTime) / INTERSTITIAL_DELAY) * 100);

  if (now >= expiresAt) {
    return children;
  }

  return (
    <Center
      component={Container}
      height="90dvh" // Note: use "dvh" unit to play nice on mobile.
    >
      <Stack alignItems="center" maxWidth={480} spacing={2}>
        <Text size="3xl">🎉</Text>
        <Heading align="center" size="xl" weight="regular">
          You’ve joined a community of successful new business owners making their mark!
        </Heading>
        <CircularProgress
          color="success"
          size={20}
          sx={{ mt: 3 }}
          value={progress}
          variant="determinate"
        />
      </Stack>
    </Center>
  );
}

export default Interstitial;
